import React from 'react';
import { Select, SelectCustom } from '@bepro-travel/fe.ui';
import { FC, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faLocationDot, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { onClickClose, onClickOverlay } from '@bepro-travel/fe.utils';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { SearchRuToursModel } from '../ts/classes/SearchRuToursModel';
import { PageCity } from '@bepro-travel/fe.shared';
import { getCountries, getMonths } from '../service';

interface OphirSearchBoxProps {
  page?: PageCity;
  searchBox: string;
}

const OphirSearchBox: FC<OphirSearchBoxProps> = (props) => {
  const [countries, setCountries] = useState<Select[]>();
  const [months, setMonths] = useState<Select[]>();
  const [model, setModel] = useState(new SearchRuToursModel());

  const [t] = useTranslation() as unknown as [(key: string) => string];
  const navigate = useNavigate();
  const [urlParams] = useSearchParams();

  useEffect(() => {
    (async () => {
      const countries = await getCountries();
      const country = countries?.find((c) => c.value === urlParams.get('countryCode'));

      const countryCity = props.page?.country.code;
      if (countries?.some((c) => c.value === countryCity)) {
        setModel({ ...model, countryCode: countryCity! });
        const months = await getMonths({ countryCode: countryCity });
        setMonths(months);
      } else {
        let monthsParams = {};
        if (country && countries?.find((c) => c.value === country)) {
          monthsParams = { countryCode: country };
          setModel({ ...model, countryCode: country });
        } else if (urlParams.get('countryCode')) {
          setModel({
            ...model,
            countryCode: urlParams.get('countryCode')!,
            checkIn: urlParams.get('checkIn')!,
          });
          monthsParams = {
            countryCode: urlParams.get('countryCode'),
            selectAll: urlParams.get('countryCode') === 'all',
          };
        } else {
          monthsParams = { selectAll: true };
        }

        const months = await getMonths(monthsParams);
        if (months) {
          setMonths(months);
        }
      }

      if (countries) {
        setCountries(countries);
      }
    })();
  }, [urlParams]); // eslint-disable-line

  const onChangeCountry = async (countryCode: string) => {
    setMonths(undefined);
    setModel({ ...model, checkIn: 'all', countryCode });
    const months = await getMonths({ countryCode, selectAll: countryCode === 'all' });

    setMonths(months);
  };

  const onClickSearch = async () => {
    const params: any = {
      countryCode: model.countryCode,
      checkIn: model.checkIn,
    };
    if (model.checkIn === 'all') {
      params.allDates = 'true';
    }

    if (model.countryCode === 'all') {
      params.allCountries = 'true';
    }
    const modelUrl = new URLSearchParams(params).toString();

    const lang = localStorage.getItem('language') || 'he';
    const pathname = lang === 'he' ? '/tour/results' : '/tourru/results';
    navigate({ pathname, search: modelUrl });
  };

  return (
    <div className="search-wrapper" onClick={onClickOverlay}>
      <div className="search-inner">
        <div className="results-responsive-header">
          <span className="title text-md">{t('search.search')}</span>
          <FontAwesomeIcon icon={faTimes as any} onClick={onClickClose} />
        </div>
        <div className="search-element location">
          <SelectCustom
            options={countries || []}
            isLoading={!countries}
            value={model.countryCode}
            onChange={onChangeCountry}
            movablePlaceholder={'.'}
            movablePlaceholderIcon={faLocationDot}
            filterOption={() => true}
            needToTranslate={true}
            appendToBody={true}
          />
        </div>
        <div className="search-element location">
          <SelectCustom
            options={months || []}
            isLoading={!months}
            value={model.checkIn}
            onChange={(checkIn) => setModel({ ...model, checkIn })}
            movablePlaceholder={'.'}
            movablePlaceholderIcon={faCalendar}
            filterOption={() => true}
            needToTranslate={true}
            appendToBody={true}
          />
        </div>
        <div className="search-button">
          <button className="btn btn-primary" onClick={onClickSearch}>
            <FontAwesomeIcon icon={faSearch as any} className="mr-5" />
            {t('search.search')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OphirSearchBox;
